import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {usePath} from 'hooks';
import {PATHS} from 'Routes';
import Page from 'components/Page';

function MyEsimsView() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  const onBackClick = () => {
    navigate(getFullPath(PATHS.home), {replace: true});
  };

  return (
    <Page
      title={t('esim.my.title')}
      navBarTitle={t('esim.my.title')}
      onBackButtonClick={onBackClick}
      isSubHeaderVisible
      className="my-esims-view"
    >
      <div>
        <h1>{t('esim.my.title')}</h1>
      </div>
    </Page>
  );
}

export {MyEsimsView};

